<template>
  <v-dialog-old ref="dialog" id="accessDialog">
    <div class="error-content">
      <h2><i class="fa fa-warning text-red"></i>Не хватает прав доступа</h2>
      <p>Доступ к этому разделу системы запрещен для вашего аккаунта.</p>
      <p>Чтобы иметь возможность входа в этот раздел, настройте права доступа
        в учетной записи на вкладке "Пользователи".</p>
    </div>
  </v-dialog-old>
</template>

<script>
export default {
  name: "AccessDenied",
  methods: {
    show () {
      this.$refs.dialog.show();
    }
  }
}
</script>

<style lang="scss">
#accessDialog {
  max-width: 50%;
}
</style>
